export const ID = 'id';
export const NAME = 'name';
export const DESCRIPTION = 'description';
export const WORKER_IDS = 'workerIds';
export const SHARE ='share';
export const EMPLOYER_ID = 'employerId';

export const WORKERS = 'workers';
export const FACILITY_ID = 'facilityId';
